import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';

import BarrierSvg from '../icons/barrier.svg';

const styles = () => ({
  header: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  barrier: {
    height: 100,
    width: 'auto',
    margin: '24px 0',
  },
});

const propTypes = {
  classes: PropTypes.shape({
    header: PropTypes.string.isRequired,
    barrier: PropTypes.string.isRequired,
  }).isRequired,
};

const UnderMaintenance = (props) => {
  const { classes } = props;
  const getAppLink =
    process.env.REACT_APP_ENV === 'stg'
      ? 'https://staging-app.text-em-all.com'
      : 'https://app.text-em-all.com';
  return (
    <div>
      <div className={classes.header}>
        <BarrierSvg className={classes.barrier} />
      </div>
      <Typography align="center" variant="h6">
        Sorry! This site is under maintenance. We will be back soon.
        <br />
        <br />
        Log into your&nbsp;
        <a href={getAppLink}>account</a>
        &nbsp;to pay online or contact us.
      </Typography>
    </div>
  );
};

UnderMaintenance.propTypes = propTypes;
export default withStyles(styles)(UnderMaintenance);
